"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
interface HalfTimeDividerProps {
  label: string;
}

/**
 * HalfTimeDivider - Displays a visual divider for half-time in the event timeline
 */
export const HalfTimeDivider: React.FC<HalfTimeDividerProps> = t0 => {
  const $ = _c(6);
  const {
    label
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex-1 border-t border-dashed border-muted-foreground/40" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <div className="px-4"><span className="text-xs font-semibold text-muted-foreground uppercase bg-card px-2 py-1 rounded border border-border">{label}</span></div>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex-1 border-t border-dashed border-muted-foreground/40" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className="relative flex items-center py-2">{t1}{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};